import Axios from "axios";
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const I18N_KEY = "i18n";
// const messages = {}

// function loadLocaleMessages() {
//   const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
//   const messages = {};
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i);
//     if (matched && matched.length > 1) {
//       const locale = matched[1];
//       messages[locale] = locales(key);
//     }
//   });
//   return messages;
// }

let instance;

class I18n {
  constructor() {
    if (!instance) {
      const config = {
        locale: process.env.VUE_APP_I18N_LOCALE || "en",
        fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
        silentTranslationWarn: process.env.NODE_ENV == "production"
      }
      // if (messages) {
      //   config.messages = messages;
      // }
      instance = new VueI18n(config);
    }
    return instance;
  }
}
const i18n = new I18n();
export default i18n;

// export const setLocaleMessage = (locale, map) => {
//   messages[locale] = map;
// }

export const i18nFormat = (fn = "t", key = "", args = undefined) => ({
  fn: `$${fn}`,
  key,
  args,
  type: I18N_KEY
});

export const readI18n = (vm, format) => {
  if (!format || format.type != I18N_KEY)
    return "";
  if (format.args && typeof format.args == "object") {
    let parsed = {};
    let args = format.args;
    Object.keys(args).forEach(key => {
      if (args[key].type == I18N_KEY) {
        parsed[key] = readI18n(vm, args[key]);
      } else {
        parsed[key] = args[key];
      }
    });
    return vm[format.fn](format.key, parsed);
  } else {
    return vm[format.fn](format.key, format.args);
  }
}

// ================================================ new function ================================================

function setI18nLanguage(lang) {
  i18n.locale = lang
  // Axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

const loadedLanguages = [];

const defaultKeySource = locale => {
  if (["local"].includes(process.env.VUE_APP_ENV)) {
    return `https://gempagesv7-test.s3.ap-southeast-1.amazonaws.com/locales/${locale}.json`
  }
  return `https://${process.env.VUE_APP_CF_URL}/locales/${locale}.json`;
};

export function loadLanguageAsync (lang, source) {

  if (!process.env.VUE_APP_SUPPORTED_LANG.includes(lang)){
    return Promise.reject();
  }

  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang || i18n.messages[lang]) setI18nLanguage(lang)
    return Promise.resolve();
  }
  
  loadedLanguages.push(lang);
  let src = source || defaultKeySource(lang);
  const version = process.env && process.env.VUE_APP_BUILD_TIMESTAMP || new Date().getTime();
  src = src + `?ver=${version}`;
  return Axios.get(src).then(response => {
    let msgs = response.data;
    i18n.setLocaleMessage(lang, msgs)
    setI18nLanguage(lang)
  });
}

i18n.loadLanguageAsync = loadLanguageAsync;

// i18n.loadLocaleMessages = loadLocaleMessages;
